import React from 'react'

import { Grid } from '@material-ui/core'
import { ResearchDetailViewType, ResearchDetailCtrlType } from './uploadDocType'
import useUploadDoc from './useUploadDoc'

import UploadFile from './uploadFile/uploadFile'
import { FieldArray } from 'react-final-form-arrays'
import useTranslate from '../../../../i18n/useTranslate'

const UploadDocView: React.FC<ResearchDetailViewType> = ({ ...props }) => {
    const translate = useTranslate()
    const {
        documentTitleList,
        isViewMode,
        initialData,
        name = 'uploadFile',
        disabledBtn = false,
        latestDocument,
        onClickOpenFile,
        accept = 'image/png,image/jpeg,image/tiff,.pdf,.doc,.docx,.jpg,.png',
        required,
        validates,
        multipleFiles,
    } = props
    const renderUploadFile = (name: string, index: number) => {
        return (
            <UploadFile
                multipleFiles={multipleFiles}
                name={`${name}.uploadFileObj`}
                dataSource={documentTitleList[index]}
                label="Upload File"
                topicID={documentTitleList[index].id}
                onChangeUpload={() => {}}
                subTitleList={documentTitleList[index].subtopic}
                initialData={initialData ? [initialData[index]] : []}
                disabled={isViewMode}
                disabledBtn={disabledBtn}
                latestDocument={latestDocument}
                required={required}
                onClickOpenFile={onClickOpenFile}
                accept={accept}
                validates={validates}
            />
        )
    }
    return (
        <Grid container>
            <FieldArray name={name}>
                {(
                    { fields }, //loop from initialData
                ) =>
                    fields.map((name, index) => (
                        // <Grid container item xs={12} key={name} spacing={5}>
                        <Grid container item xs={12} justify={'flex-end'}>
                            {documentTitleList &&
                                documentTitleList.length > 0 &&
                                documentTitleList[index] &&
                                renderUploadFile(name, index)}
                        </Grid>
                        // </Grid>
                    ))
                }
            </FieldArray>
        </Grid>
    )
}

let UploadDocFile: React.FC<ResearchDetailCtrlType> = (props: ResearchDetailCtrlType) => {
    const uploadDocModel = useUploadDoc(props)
    return <UploadDocView {...uploadDocModel} {...props} />
}

export default UploadDocFile
